// This is the entry point for all the Stimulus Controllers that are shared between the "admin app" and the "public app"

import { application } from "../application"

import PhoneNumberInputController from "./phone_number_input_controller"
application.register("phone-number-input", PhoneNumberInputController)

import StripePaymentMethodController from "./stripe_payment_method_controller"
application.register("stripe-payment-method", StripePaymentMethodController)

import PasswordStrengthFeedbackController from "./password_strength_feedback_controller"
application.register("password-strength-feedback", PasswordStrengthFeedbackController)
